const config = {
  apiBaseUri: import.meta.env.REACT_APP_API_URI,
  chatHost: import.meta.env.REACT_APP_CHAT_HOST,
  chatPath: import.meta.env.REACT_APP_CHAT_PATH,
  amplifyConfig: {
    awsProjectRegion: import.meta.env.REACT_APP_AWS_PROJECT_REGION,
    awsCognitoRegion: import.meta.env.REACT_APP_AWS_COGNITO_REGION,
    awsUserPoolId: import.meta.env.REACT_APP_AWS_USER_POOL_ID,
    awsUserPoolWebClientId: import.meta.env.REACT_APP_AWS_USER_POOL_CLIENT
  }
}

export default config
